import React from 'react'
import { Resource } from '../../utils/types'
import ResourceCard from './ResourceCard'
import '../../styles/ResourceSection/ResourceCards.scss'
import articleOne from '../../static/images/how-to-prepare-for-your-phone-call.png'
import articleTwo from '../../static/images/how-much-does-a-financial-advisor-cost.png'
import articleThree from '../../static/images/do-i-have-enough-to-work-with-a-financial-advisor.png'
import articleFour from '../../static/images/do-i-need-a-financial-advisor.png'

const resourceCards: Resource[] = [
  {
    articleUrl: 'https://smartasset.com/financial-advisor/questions-to-ask-a-financial-advisor',
    imageUrl: articleOne,
    title: '10 Questions to Ask Your Financial Advisor',
    description: 'The aid of a financial advisor can be helpful regardless of whether you’re young, retired or somewhere...'
  },
  {
    articleUrl: 'https://smartasset.com/financial-advisor/financial-advisor-cost',
    imageUrl: articleTwo,
    title: 'How Much Does a Financial Advisor Cost?',
    description: 'As you strive to reach your financial goals and prepare for retirement, you may consider turning to a fin...'
  },
  {
    articleUrl: 'https://smartasset.com/financial-advisor/ask-an-advisor-financial-advisor-small-accounts',
    imageUrl: articleThree,
    title: 'Do I Have Enough to Work With a Financial Advisor?',
    description: 'Often, financial advisors charge a fee based on the amount of money, called assets under management (AU...'
  },
  {
    articleUrl: 'https://smartasset.com/financial-advisor/do-i-need-a-financial-advisor',
    imageUrl: articleFour,
    title: 'Do I Need a Financial Advisor?',
    description: ' Financial advisors can assist their clients with their finances in a number of ways. In fact, ' +
            'they often specialize in some combination of investment management, fin..' //
  }
]

const ResourceCardList = () => {
  return (
        <div className="resource_cards">
            {resourceCards.map((resource, i) => (
                <ResourceCard key={i} resource={resource} />
            ))}
        </div>
  )
}

export default ResourceCardList
